import { Clock, User } from "lucide-react";
import { fmtStamp } from "../lib/datetime";

// Admin-portal-only traceability line: "Created {date & time} · by {name}".
// Never rendered on the public-facing page.
export function AuditMeta({ createdAt, createdBy, className = "" }) {
  if (!createdAt && !createdBy) return null;
  return (
    <div data-testid="audit-meta" className={`text-xs text-muted2 mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 ${className}`}>
      {createdAt && (
        <span className="inline-flex items-center gap-1.5">
          <Clock className="w-3.5 h-3.5" /> Created {fmtStamp(createdAt)}
        </span>
      )}
      {createdBy && (
        <span className="inline-flex items-center gap-1.5">
          <User className="w-3.5 h-3.5" /> by {createdBy}
        </span>
      )}
    </div>
  );
}
